import { useEffect, useRef } from "react";
import { AfbService } from "../../../../services/AfbService";
import { SpaceService } from "../../../../services/SpaceService";
import { CommonService } from "../../../../services/CommonService";
import { CustomerService } from "../../../../services/CustomerService";
import { AlboQueryService } from "../../../../services/AlboQueryService";
import { ChangeAlertCallbackType } from "../../../Root";

export const useAFBFunction = (changeAlert: ChangeAlertCallbackType) => {
    const afbService = useRef<AfbService>();
    const spaceService = useRef<SpaceService>();
    const commonService = useRef<CommonService>();
    const customerService = useRef<CustomerService>();
    const alboQueryService = useRef<AlboQueryService>();

    const handleCustomerList = async (payolad) => {
        const request = await afbService.current.afbCustomersList(payolad);
        if (request.data.response === "OK") {
            return request.data.widget[0];
        } else {
            return false;
        }
    };

    const handleCompanyCards = async (payolad) => {
        const request = await afbService.current.afbCompanyCards(payolad);
        if (request.data.response === "OK") {
            let widg = request.data.widget[0];
            if (widg.type === "companyCards" && widg.content) {
                return widg;
            }
            return false;
        } else {
            return false;
        }
    };

    const handleContactList = async (payload) => {
        const request = await afbService.current.afbContactList(payload);
        if (request.data.response === "OK") {
            return request.data.widget;
        } else {
            return false;
        }
    };

    const handleGetAccounts = async (payload) => {
        const request = await afbService.current.afbGetAccounts(payload);
        if (request.data.response === "OK") {
            return request.data.widget[0].data.content;
        } else {
            return false;
        }
    };

    const handleClabeCreate = async (payload) => {
        const request = await afbService.current.afbGetAccounts(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };
    
    // ADMINS ----------------------------------------------
    
    const handleSpacesGet = async (payload, customer?) => {
        const request = await spaceService.current.spacesGet(payload);
        if (request.data.response === "OK") {
            return customer ? request.data.widget : request.data.widget[1].data.content;
        } else {
            return false;
        }
    };

    const handleAdminList = async (payload) => {
        const request = await afbService.current.afbAdminList({data: payload});
        if (request.data.response === "OK") {
            let widget = request.data.widget[0];
            let content = {
                users: widget.data.content.documents,
                roles: widget.data.content.roles,
                count: widget.data.content.count,
                userList: true
            }
            let data = {
                config: widget.config,
                content: content,
                type: widget.type
            }
            return data;
        } else {
            return false;
        }
    };

    const handleAdminUpdate = async (payload) => {
        const request = await afbService.current.afbAdminUpdate(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    const handleAdminCreate = async (payload) => {
        const request = await afbService.current.afbAdminCreate(payload);
        if (request.data.response === "OK") {
            return request.data.content;
        } else {
            return false;
        }
    };

    // ADMINS ACTIONS ----------------------------------------------

    const handleAlboQuery = async (payload) => {
        const request = await alboQueryService.current.executeQuery(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    const handleResendEmail = async (payload) => {
        const request = await afbService.current.afbResendEmail(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    const handleRestoreSession = async (payload) => {
        const request = await afbService.current.afbValidateSession(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    const handleOtpTokenGetAllowed = async (payload) => {
        const request = await afbService.current.otpTokenGetAllowed(payload);
        if (request.data.response === "OK") {
            return request.data.content["allowed"].indexOf("albo-token") === 0;
        } else {
            return false;
        }
    };

    const HandleOtpTokenDisabledConfirm = async (payload) => {
        const request = await afbService.current.otpTokenDisabledConfirm(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };
    
    // RECURRING OPERATIONS ----------------------------------------------

    const handleRecurringList = async (payload) => {
        const request = await afbService.current.afbRecurringList(payload);
        if (request.data.response === "OK") {
            return request.data.widget[0].data;
        } else {
            return false;
        }
    };

    const handleRecurringSave = async (payload) => {
        const request = await afbService.current.afbRecurringSave(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    const handleRecurringUpdate = async (payload) => {
        const request = await afbService.current.afbRecurringUpdate(payload);
        if (request.data.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    
    const handleCatalog = async (type: string) => {
        let data = {
            catalog: {
                id: type
            },
        };

        const response = await commonService.current.getCatalog(data);
        if(response?.data?.response === 'OK'){
            return (response.data.catalog);
        } else {
            changeAlert(true, 'error', 'Ocurrió un error, ' + response.data.message);
            return false;
        }
    };

    const handleCustomerSegmentUpdate = async (payload) => {
        const request = await customerService.current.customerSegmentUpdate(payload);
        if (request?.data?.response === "OK") {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        afbService.current = new AfbService(changeAlert);
        spaceService.current = new SpaceService(changeAlert);
        commonService.current = new CommonService(changeAlert);
        customerService.current = new CustomerService(changeAlert);
        alboQueryService.current = new AlboQueryService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        handleContactList,
        handleCustomerList,
        handleCompanyCards,
        handleGetAccounts,
        handleClabeCreate,
        // ADMIN -----------
        handleAdminList,
        handleSpacesGet,
        handleAdminUpdate,
        handleAdminCreate,
        // ADMIN ACTIONS ---
        handleAlboQuery,
        handleResendEmail,
        handleRestoreSession,
        handleOtpTokenGetAllowed,
        HandleOtpTokenDisabledConfirm,
        // OPERATIONS ---
        handleRecurringList,
        handleRecurringSave,
        handleRecurringUpdate,
        // COMMON ---
        handleCatalog,
        // CUSTOMER ---
        handleCustomerSegmentUpdate
    };
};
